import React from "react";
import * as Flex from "@twilio/flex-ui";
import * as Redux from "react-redux";
import UhaulStore from "./CustomRedux/UhaulStore";

class App extends React.Component {
      constructor(props) {
        super(props);
        this.state = { cannedProps: null };
        this.handler = this.handler.bind(this)
    }

    componentDidMount()
    {
        if(document != null && document.title !== "U-Haul Live Chat")
        {
            document.title = "U-Haul Live Chat";
        }
    }

    handler() {
        this.setState({
            cannedProps: this.props
        })
    }
  render() {
    const { manager } = this.props;

    if (!manager) {
      return null;
    }

    return (
      <Redux.Provider store={UhaulStore}>
        <Flex.ContextProvider manager={manager}>
          <Flex.RootContainer />
        </Flex.ContextProvider>
      </Redux.Provider>
    );
  }
}

export default App;
